module.exports = __webpack_public_path__ + "img/west-fall-1920x550.716e16ed.jpg";